import React from 'react';
import propTypes from 'prop-types';
import { MainContent, Content } from 'client/components/App';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import ConnectedEATDOptionsForm from 'client/components/EATD/ConnectedEATDOptionsForm';
import ConnectedEATDTester from 'client/components/EATD/ConnectedEATDTester';
import InstanceDashboard from 'client/components/Instance/InstanceDashboard';
import InstanceParentAlert from 'client/components/Instance/components/InstanceParentAlert';
import InstanceWidgetPlan from 'client/components/Instance/components/InstanceWidgetPlan';
import InstanceWidgetControls from 'client/components/Instance/components/InstanceWidgetControls';

class ConnectedEATDModule extends React.Component {

  static propTypes = {
    instanceId: propTypes.string.isRequired,
    tab: propTypes.string.isRequired,
    push: propTypes.func.isRequired,
  };

  handleSelectTab = newTab => {
    if (newTab === this.props.tab) return;
    const { instanceId } = this.props;
    this.props.push(`/instance/eatd/${instanceId}/${newTab}`);
  };

  render () {
    const { instanceId, tab } = this.props;
    return (
      <Content>
        <Helmet>
          <title>Extended Anonymization → TOPdesk</title>
        </Helmet>
        <MainContent>
          <InstanceParentAlert />
          <div className="row">
            <div className="col-xs-12 col-md-6 col-lg-3">
              <InstanceWidgetPlan
                id={instanceId}
                shouldReadInstance={false}
              />
            </div>
            <div className="col-xs-12 col-md-6 col-lg-3">
              <InstanceWidgetControls
                id={instanceId}
                shouldReadInstance={false}
              />
            </div>
            <div className="col-xs-12 col-md-6 col-lg-3"></div>
            <div className="col-xs-12 col-md-6 col-lg-3"></div>
          </div>
          <InstanceDashboard
            id={instanceId}
            tab={tab}
            OptionsFormComponent={ConnectedEATDOptionsForm}
            TesterComponent={ConnectedEATDTester}
            onSelectTab={this.handleSelectTab}
            endpointOrder={['topdesk']}
          />
        </MainContent>
      </Content>
    );
  }

}

const actions = {
  push,
};

export default connect(null, actions)(ConnectedEATDModule);
